// extracted by mini-css-extract-plugin
export default {"editTopicBtn":"TopicInfo_editTopicBtn__TlxDB","topic":"TopicInfo_topic__vF7uy"};